var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14",
    "data-name": "Group 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.823,
    height: 116.907,
    viewBox: "0 0 101.823 116.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-upload-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 101.823,
    height: 116.907,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M100.548,166.181h-2.8V140.739L75.578,127.674v25.981l22.168,12.895v.077h2.8v-.077l22.168-12.895V127.869l-22.168,12.876Z",
    transform: "translate(-48.235 -81.483)",
    fill: "#e761a0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    clipPath: "url(#home-upload-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M98.287,80.361V36.489a4.959,4.959,0,0,0-1.4-9.709A4.881,4.881,0,0,0,93.6,28.065l.024-.039L55.706,6.14l-.021.037a4.97,4.97,0,0,0,.165-1.209A4.939,4.939,0,1,0,46.133,6.16l-.015-.019L8.51,28.114l.011.022a4.9,4.9,0,0,0-3.582-1.57,4.959,4.959,0,0,0-1.4,9.709V80.362a4.958,4.958,0,0,0,1.4,9.707,4.9,4.9,0,0,0,3.575-1.562l0,.014,37.616,22.245a4.937,4.937,0,1,0,9.6.1L93.581,88.767a4.881,4.881,0,0,0,3.3,1.3,4.959,4.959,0,0,0,1.4-9.709M9.772,30.522,47.694,8.706a4.9,4.9,0,0,0,1.817,1V31.46h2.8V9.709a4.925,4.925,0,0,0,2.043-1.19l-.008.015L92.1,30.551a13.711,13.711,0,0,0,0,2.4l-19,10.984L52.313,31.841v-.029h-2.8v.028l-20.621,12L9.765,32.572a5.01,5.01,0,0,0,.008-2.05M95.485,80.36A5.066,5.066,0,0,0,92.1,86.286L54.328,108.365a4.915,4.915,0,0,0-2.015-1.166V85.5h-2.8v21.7a4.887,4.887,0,0,0-1.908,1.078L9.707,86.322A4.877,4.877,0,0,0,6.34,80.361V36.274a4.93,4.93,0,0,0,2.068-1.211v0l19.764,11.6,1.417-2.411L50.917,56.829,72.411,44.345l1.4,2.418L93.626,35.472l-.025-.041a4.885,4.885,0,0,0,1.883,1.057Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7bb13e1ce5d15ff1f9df914aa07a9a09.svg";
export { ForwardRef as ReactComponent };